<template>
  <v-container fluid="fluid" grid-list-md="grid-list-md">
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t("pageHeader.comments") }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12 sm6="sm6">
          <VueCtkDateTimePicker
            v-model="setDate"
            label="Select Date Range"
            range
            @input="setDateTime"
            overlay="overlay"
          >
          </VueCtkDateTimePicker>
        </v-flex>
        <v-flex xs12 sm2> </v-flex>
        <v-flex xs12 sm4="sm4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line="single-line"
            hide-details="hide-details"
            clearable="clearable"
          >
          </v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="comments"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="text-xs-left">{{ props.item.userName }}</td>
            <td class="text-xs-left">{{ props.item.comment }}</td>
            <td class="text-xs-left">{{ props.item.typeID }}</td>
            <td class="text-xs-left">
              {{ $moment(props.item.createDateTime).format("MM/DD/YYYY") }}
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import activityService from "../service.js";
import { mapGetters } from "vuex";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";

export default {
  data() {
    return {
      setDate: {
        start: this.$moment(new Date()).subtract(30, "days"),
        end: this.$moment(new Date())
      },
      filter: {
        fromDate: this.$moment(new Date())
          .subtract(30, "days")
          .format("MM/DD/YYYY h:m a"),
        toDate: this.$moment(new Date()).format("MM/DD/YYYY h:m a")
      },
      comments: [],
      loading: false,
      headers: [
        {
          text: this.$t("labels.user"),
          value: "userName",
          sortable: true
        },
        {
          text: this.$t("labels.comment"),
          value: "comment",
          sortable: true
        },
        {
          text: this.$t("labels.typeID "),
          value: "typeId",
          sortable: true
        },
        {
          text: this.$t("labels.createdAt"),
          value: "createDateTime",
          sortable: true
        }
      ],
      search: null,
      pagination: {
        rowsPerPage: 10,
        sortBy: "createDateTime",
        descending: false
      }
    };
  },
  components: {
    VueCtkDateTimePicker
  },
  async created() {
    this.getList();
  },
  computed: {
    ...mapGetters("location", ["location"])
  },
  methods: {
    async getList() {
      var proFilter = {
        // fromDate:"2019-10-7 21:52:56",
        // toDate: "2017--7 15:49:06"
      };
      if (this.filter.fromDate)
        proFilter.fromDate = this.$moment(this.filter.fromDate).format("MM/DD/YYYY h:m a");
      if (this.filter.toDate)
        proFilter.toDate = this.$moment(this.filter.toDate).format("MM/DD/YYYY h:m a");
      this.loading = true;
      return await activityService.getAllComments(proFilter).then(response => {
        console.log("open invoice list", response);
        this.comments = response.data;
        this.loading = false;
        return response;
      });
    },
    setDateTime(val) {
      if (val) {
        if (val.start) this.filter.fromDate = val.start;
        if (val.end) this.filter.toDate = val.end;
        this.getList();
      }
    }
  }
};
</script>

<style scoped></style>
